export const KEY = 'app';

export const FETCH_STATUS = 'fetchStatus';
export const NOTIFICATION = 'notification';
